/** Formatting shared by the bulk registration pages. */

export function money(cents: number): string {
  return `$${(cents / 100).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

/** "Sat, Apr 18" — compact date for list rows. */
function parse(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** The last day when it's a different day from the first (an end time on
 *  the same day is still one day). */
function lastDay(start: Date, endIso: string | null | undefined): Date | null {
  const end = parse(endIso);
  return end && end.toDateString() !== start.toDateString() && end > start ? end : null;
}

/** "Sat, Nov 28"; a multi-day tournament "Sat–Sun, Nov 28–29", or across
 *  months "Sat, Nov 30 – Mon, Dec 1". */
export function shortDate(iso: string | null | undefined, endIso?: string | null): string | null {
  const d = parse(iso);
  if (!d) return null;
  const one = (x: Date) => x.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
  const end = lastDay(d, endIso);
  if (!end) return one(d);
  if (d.getMonth() === end.getMonth() && d.getFullYear() === end.getFullYear()) {
    const wd = (x: Date) => x.toLocaleDateString(undefined, { weekday: 'short' });
    const month = d.toLocaleDateString(undefined, { month: 'short' });
    return `${wd(d)}–${wd(end)}, ${month} ${d.getDate()}–${end.getDate()}`;
  }
  return `${one(d)} – ${one(end)}`;
}

/** "Saturday, November 28, 2026"; a multi-day tournament "November 28–29,
 *  2026", across months "November 30 – December 1, 2026". */
export function longDate(iso: string | null | undefined, endIso?: string | null): string | null {
  const d = parse(iso);
  if (!d) return null;
  const end = lastDay(d, endIso);
  if (!end) return d.toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  const md = (x: Date) => x.toLocaleDateString(undefined, { month: 'long', day: 'numeric' });
  if (d.getFullYear() !== end.getFullYear()) {
    const mdy = (x: Date) => x.toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' });
    return `${mdy(d)} – ${mdy(end)}`;
  }
  if (d.getMonth() === end.getMonth()) return `${md(d)}–${end.getDate()}, ${d.getFullYear()}`;
  return `${md(d)} – ${md(end)}, ${d.getFullYear()}`;
}

export const STATUS_LABEL: Record<string, string> = {
  confirmed: 'Confirmed',
  pending_approval: 'Pending approval',
  pending_payment: 'Awaiting payment',
};
